import ApiHelper from "./ApiHelper";

class ATSServices {

    static async CreateAtsCandidates(body) {
        return ApiHelper.postAuthenticated("merge/candidate", body);
    }

    static async GetAtsCandidates(body) {
        return ApiHelper.getAuthenticated(`merge/enterprise/${body.atsId}`);
    }

    static async FindAtsCandidateByEmail(body) {
        return ApiHelper.postAnonymous(`merge/candidate/on-boarding`, body);
    }

    static async GetAtsListByEnterprise(body) {
        return ApiHelper.getAuthenticated(`merge/ats/enterprise/${body}`);
    }

    static async GetAtsToken(body) {
        return ApiHelper.postAuthenticated("merge/ats-token", body);
    }

    static async RequestScore(body) {
        return ApiHelper.postAuthenticated(`professionals/${body.enterpriseId}/request-score`, body);
    }

    static async CreateAtsAccountToken(body) {
        return ApiHelper.postAuthenticated("merge/ats-access-token", body);
    }

    static async DisconnectAtsAccount(body) {
        return ApiHelper.postAuthenticated("merge/disconnect-ats-account", body);
    }

    static async RequestAtsScore(body) {
        return ApiHelper.postAuthenticated('merge/request-ats-score', body);
    }

}
export default ATSServices;

